// TAGGRS Enhanced Fix - Includes view_item_list variant ID fetching
// This script handles all ecommerce events and fetches variant data for view_item_list

(function() {
    // Cache for product variant data to avoid repeated API calls
    const productVariantCache = new Map();
    
    // Function to extract product handle from URL
    function extractHandleFromUrl(url) {
        const match = url.match(/\/products\/([^/?]+)/);
        return match ? match[1] : null;
    }
    
    // Function to fetch product variant data
    async function fetchProductVariants(handle) {
        if (productVariantCache.has(handle)) {
            return productVariantCache.get(handle);
        }
        
        try {
            const response = await fetch(`/products/${handle}.js`);
            const product = await response.json();
            const firstVariantId = product.variants && product.variants[0] ? product.variants[0].id : null;
            
            productVariantCache.set(handle, firstVariantId);
            return firstVariantId;
        } catch (error) {
            console.log(`Failed to fetch variant for ${handle}:`, error);
            productVariantCache.set(handle, null);
            return null;
        }
    }
    
    // Function to build product handle to ID mapping from page
    function buildProductMapping() {
        const mapping = new Map();
        const productLinks = document.querySelectorAll('a[href*="/products/"]');
        
        productLinks.forEach(link => {
            const handle = extractHandleFromUrl(link.href);
            if (handle) {
                // Try to find associated product ID from nearby elements
                const productCard = link.closest('[id*="product-item"], .product-item, .product-card');
                if (productCard && productCard.id) {
                    const idMatch = productCard.id.match(/product-item-(\d+)/);
                    if (idMatch) {
                        mapping.set(idMatch[1], handle);
                    }
                }
            }
        });
        
        return mapping;
    }
    
    // Initialize the enhanced dataLayer interceptor
    const initializeEnhancedFix = async () => {
        const originalPush = Array.prototype.push;
        let isProcessing = false;
        
        // Build product ID to handle mapping
        const productMapping = buildProductMapping();
        console.log('Product mapping built:', productMapping.size, 'products found');
        
        // Ensure dataLayer exists
        window.dataLayer = window.dataLayer || [];
        
        // Override the push method
        window.dataLayer.push = async function(event) {
            // Prevent infinite recursion
            if (isProcessing) {
                return originalPush.call(this, event);
            }
            
            isProcessing = true;
            
            // Process ecommerce events with items
            if (event.ecommerce && event.ecommerce.items && Array.isArray(event.ecommerce.items)) {
                
                // Special handling for view_item_list events
                if (event.event === 'view_item_list') {
                    console.log('Processing view_item_list event with variant fetching...');
                    
                    // Process each item and fetch variant data
                    for (const item of event.ecommerce.items) {
                        if (item.id && !item.id.toString().includes('shopify_ZZ_')) {
                            const productId = item.id.toString();
                            const handle = productMapping.get(productId);
                            
                            if (handle) {
                                const variantId = await fetchProductVariants(handle);
                                
                                if (variantId) {
                                    const newId = `shopify_ZZ_${productId}_${variantId}`;
                                    item.id = newId;
                                    item.item_id = newId;
                                    console.log(`Updated ${productId} -> ${newId}`);
                                } else {
                                    const newId = `shopify_ZZ_${productId}`;
                                    item.id = newId;
                                    item.item_id = newId;
                                    console.log(`Updated ${productId} -> ${newId} (no variant)`);
                                }
                            } else {
                                // Fallback: just add shopify_ZZ prefix
                                const newId = `shopify_ZZ_${productId}`;
                                item.id = newId;
                                item.item_id = newId;
                                console.log(`Fallback update ${productId} -> ${newId}`);
                            }
                        }
                    }
                } else {
                    // Handle other ecommerce events (view_item, add_to_cart, etc.)
                    event.ecommerce.items.forEach(item => {
                        if (item.id && !item.id.toString().includes('shopify_ZZ_')) {
                            let variantId = null;
                            
                            // Try standard variant detection methods
                            const urlParams = new URLSearchParams(window.location.search);
                            variantId = urlParams.get('variant');
                            
                            if (!variantId) {
                                const variantInput = document.querySelector('input[name="id"], select[name="id"]');
                                if (variantInput && variantInput.value) {
                                    variantId = variantInput.value;
                                }
                            }
                            
                            if (!variantId && typeof window.product !== 'undefined' && window.product.selected_or_first_available_variant) {
                                variantId = window.product.selected_or_first_available_variant.id;
                            }
                            
                            // Construct the GMC-compatible ID
                            let newId;
                            if (variantId) {
                                newId = `shopify_ZZ_${item.id}_${variantId}`;
                            } else {
                                newId = `shopify_ZZ_${item.id}`;
                            }
                            
                            item.id = newId;
                            item.item_id = newId;
                        }
                    });
                }
            }
            
            isProcessing = false;
            
            // Call original push method
            return originalPush.call(this, event);
        };
        
        console.log('TAGGRS Enhanced Fix: DataLayer interceptor with view_item_list variant fetching installed');
    };
    
    // Initialize when DOM is ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initializeEnhancedFix);
    } else {
        initializeEnhancedFix();
    }
})();